import CampaignIcon from '@mui/icons-material/Campaign';
import { Fab, Tooltip } from '@mui/material';
import React from 'react';
import { useAlertUiTranslation } from '../../../../hooks';
import { AlertFabSlideout } from './AlertFabSlideout';
import { useAlertSlideout } from './useAlertSlideout';
export const AlertFab = (props) => {
    const { t, ready } = useAlertUiTranslation();
    const { handleOpenSlideout, open, reloadFlag, handleCloseSlideout, handleSelect, handleCreateAlert } = useAlertSlideout({
        alertsSentUrl: props.alertsSentUrl,
    });
    if (!ready) {
        return null;
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(Tooltip, { title: t('pages.toolbar.notification.send'), placement: 'left' },
            React.createElement(Fab, { color: 'error', "aria-label": 'notification', sx: props.fabStyle || { right: 20, bottom: 20, position: 'fixed' }, onClick: handleOpenSlideout },
                React.createElement(CampaignIcon, null))),
        React.createElement(AlertFabSlideout, { isOpen: open, reloadFlag: reloadFlag, onClose: handleCloseSlideout, onAlertCreate: handleCreateAlert, onSelect: handleSelect })));
};
